import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CamerasRoutes } from './cameras.routing';

import { GoProComponent } from './go-pro/go-pro.component';
import { MainCameraComponent } from './main-camera/main-camera.component';
import { RicohThetaZ1Component } from './ricoh-theta-z1/ricoh-theta-z1.component';
import { NctechIstarPulsarComponent } from './nctech-istar-pulsar/nctech-istar-pulsar.component';
import { RicohThetaVComponent } from './ricoh-theta-v/ricoh-theta-v.component';
import { Insta360OneXComponent } from './insta360-one-x/insta360-one-x.component';
import { Insta360Pro1Component } from './insta360-pro1/insta360-pro1.component';
import { Insta360Pro2Component } from './insta360-pro2/insta360-pro2.component';
import { GoproFusionComponent } from './gopro-fusion/gopro-fusion.component';
import { GoproFusionMaxComponent } from './gopro-fusion-max/gopro-fusion-max.component';
import { RicohThetaSComponent } from './ricoh-theta-s/ricoh-theta-s.component';
import { LabpanoPilotERAComponent } from './labpano-pilot-era/labpano-pilot-era.component'
import { LabpanoPilotOneComponent } from './labpano-pilot-one/labpano-pilot-one.component';

import { ComponentsModule } from '../../shared/components/components.module';

@NgModule({
	declarations: [
		GoProComponent, 
		MainCameraComponent, 
		RicohThetaZ1Component, 
		NctechIstarPulsarComponent, 
		RicohThetaVComponent, 
		Insta360OneXComponent, 
		Insta360Pro1Component, 
		Insta360Pro2Component, 
		GoproFusionComponent, 
		GoproFusionMaxComponent, 
		RicohThetaSComponent, 
		LabpanoPilotERAComponent, LabpanoPilotOneComponent,
	],
	imports: [CommonModule, CamerasRoutes, TranslateModule, ComponentsModule, RouterModule],
	exports: [MainCameraComponent]
})
export class CamerasModule { }
